import { render, staticRenderFns } from "./AttachmentPassword.vue?vue&type=template&id=33161d2b&scoped=true&"
import script from "./AttachmentPassword.vue?vue&type=script&lang=js&"
export * from "./AttachmentPassword.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentPassword.vue?vue&type=style&index=0&id=33161d2b&prod&lang=css&"
import style1 from "./AttachmentPassword.vue?vue&type=style&index=1&id=33161d2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33161d2b",
  null
  
)

export default component.exports